import { IconName } from "@blueprintjs/icons";

export const legacyToBlueprintIcon = (icon: string): IconName => {
  switch (icon) {
    case "balance.png":
      return "dollar";
    case "contract.png":
      return "document";
    case "inventory.png":
      return "box";
    case "edit.png":
      return "edit";
    case "industry.png":
      return "cube-add";
    case "task.png":
      return "tick-circle";
    case "truck2.png":
      return "truck";
    case "equipment.png":
      return "cog";
    case "catalog.png":
      return "document-share";
    default:
      return icon as IconName;
  }
};
